import { useEffect, useState, useCallback } from "react";
import { api } from "../api";

export function useClaudeAgents() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const list = await api.listAgents();
      setAgents(list);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Admins create agents in the Admin page (often another tab); refetch when
  // this tab regains focus so the picker isn't stale until a hard refresh.
  useEffect(() => {
    const onFocus = () => refresh();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [refresh]);

  return { agents, loading, error, refresh };
}
